export enum Codes {
  PTZ0000 = 'PTZ0000',
  PTZ0001 = 'PTZ0001',
  PTZ0002 = 'PTZ0002',
}
